import { useAtomValue } from 'jotai';

import UserProfile from '@/components/userProfile';
import { userIdAtom } from '@/services/globalState';

/** Your own profile, opened from Account, with its edit screens beside it in the same stack. */
export default function AccountProfileRoute() {
  const currentUserId = useAtomValue(userIdAtom);

  if (!currentUserId) {
    return null;
  }

  return <UserProfile userId={String(currentUserId)} />;
}
